<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        회사정보관리
    </h4>
</div>

<div class="modal-body">
    <span class="font-weight-bold">
        {{companyInfo?.companyNm}}
    </span>
    <span>
        을 삭제 하시겠습니까?
    </span>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            확인
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()"
        ngbAutofocus>
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>
